import {Component, Input, OnInit} from "@angular/core";

import {AbstractControl, FormControl} from "@angular/forms";

@Component({
    selector: "app-datepicker",
    templateUrl: "./datepicker.component.html",
    styleUrls: ["./datepicker.component.scss"]
})
export class DatepickerComponent implements OnInit {

    @Input()
    control: FormControl|AbstractControl;

    /** @deprecated **/
    @Input()
    disabled: boolean;

    ngOnInit(): void {
    }


}
